import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { ReportsService } from '../../../core/services/reports.service';
import { ContainerReportData } from '../../../core/models/container-report-data.model';
import { ContainerReportFilter } from '../../../core/dtos/container-report-filter.dto';
import { ContainerTypeService } from '../../../core/services/container-type.service';
import { ClientService } from '../../../core/services/client.service';
import { FormsModule } from '@angular/forms';
import { StateService } from '../../../core/services/state.service';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-customer-report',
  standalone: true,
  templateUrl: './customer-report.component.html',
  styleUrls: ['./customer-report.component.scss'],
  imports: [
    CommonModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatSelectModule,
    MatInputModule,
    FormsModule,
    DatePipe,
    RouterModule,
  ],
})
export class CustomerReportComponent implements OnInit {
  displayedColumns: string[] = ['nroSerie', 'type', 'client', 'status'];
  dataSource: MatTableDataSource<ContainerReportData> =
    new MatTableDataSource<ContainerReportData>();
  containerTypes: { id: number; name: string }[] = [];
  statuses: { id: number; name: string }[] = [];
  clients: { id: number; razonSocial: string }[] = [];
  showFilters: boolean = false;

  filter: ContainerReportFilter = {
    containerTypeId: null,
    stateId: null,
    clientId: null,
    searchTerm: '',
  };

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private reportsService: ReportsService,
    private containerTypeService: ContainerTypeService,
    private clientService: ClientService,
    private stateService: StateService,
  ) {}

  ngOnInit(): void {
    this.loadFilters();
    this.getContainerReportData();
    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'nroSerie':
          return item.container.nroSerie;
        case 'type':
          return item.container.containerType.name;
        case 'client':
          return item.container.client.razonSocial;
        case 'status':
          return item.status || '';
        default:
          return '';
      }
    };
  }

  getContainerReportData(): void {
    this.reportsService.getReportContainer(this.filter).subscribe(data => {
      this.dataSource.data = data;
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
  }

  loadFilters(): void {
    this.containerTypeService.getContainerTypes().subscribe(types => (this.containerTypes = types));
    this.stateService.getStates().subscribe(statuses => (this.statuses = statuses));
    this.clientService.getClients().subscribe(clients => (this.clients = clients));
  }

  toggleFilters(): void {
    this.showFilters = !this.showFilters;
  }

  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.filter.searchTerm = filterValue.trim().toLowerCase();
    this.getContainerReportData();
  }

  applySelectFilter(filterValue: any, filterKey: keyof ContainerReportFilter): void {
    this.filter = { ...this.filter, [filterKey]: filterValue };
    this.getContainerReportData();
  }

  resetFilters(): void {
    this.filter = {
      containerTypeId: null,
      stateId: null,
      clientId: null,
      searchTerm: '',
    };
    this.getContainerReportData();
  }
}
